export default "__VITE_ASSET__ff352a0e__"